import React from 'react'
import { flowRight } from 'lodash'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { useTranslation } from 'react-i18next'
import { useRouteMatch } from 'react-router-dom'

import ControlledModal from 'components/Modal/ControlledModal'
import UserIdentification from 'components/User/UserIdentification/UserIdentification'

const UserIdentificationModal = () => {
    const match = useRouteMatch()

    const { t } = useTranslation('user')

    return (
        <ControlledModal
            routedModal
            name="user-identification-modal"
            context="userIdentificationModal"
            initialTitle={t('user:userIdentification.modalTitle')}
            requireUserInput={false}
        >
            {() => (
                <UserIdentification context={match.params.context} />
            )}
        </ControlledModal>
    )
}

export default flowRight(
    withErrorBoundaryNoRender,
)(UserIdentificationModal)
